export default "__VITE_ASSET__E9w30ubT__"